module.exports = "<div class=\"weui_media_bd\"><slot></slot></div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./components/media/media-body.vue
 ** module id = 162
 ** module chunks = 0
 **/